import React, { useState } from "react";
import styles from "./MatchCard.module.css";
import { API_BASE_URL } from "../../services/apiHandler";
const getImageUrl = (imgUrl) => `${API_BASE_URL}/${imgUrl}`;

const MatchCard = ({ match }) => {
 

  const [showModal, setShowModal] = useState(false);
 

  const { sport_name, game_title, game_date, game_time, teams } = match;
  console.log("match data", match);

  const teamsData = teams?.teams;
  console.log("teams name and Images", teamsData);

  const random = () => {
    const backgroundColor = ["#98DC7F", "#C36F91", "#7ED9C3",];
    const randomColors = backgroundColor[Math.floor(Math.random() * backgroundColor.length + 0)];
    return randomColors;
  }

  return (
    <div className={styles.card} style={{backgroundColor:random()}}>
      <h2 className={styles.gameName}>{sport_name}</h2>
      <p className={styles.title}>{game_title}</p>
     
      {
        teamsData.length <= 2 && (
          <>
        <div className={styles.teamsContainer}>
            <div className={styles.team}>
              <img src={getImageUrl(teamsData[0]?.team_img)} alt={teamsData[0]?.team_name} className={styles.logo} />
              <p className={styles.team_name}>{teamsData[0]?.team_name}</p>
            </div>
            <span className={styles.vs}>VS</span>

            <div className={styles.team}>
              <img src={getImageUrl(teamsData[1]?.team_img)} alt={teamsData[1]?.team_name} className={styles.logo} />
              <p className={styles.team_name}>{teamsData[1]?.team_name}</p>
            </div>
      </div>
     </>
      )
    }
             
        {/* {teamsData.slice(0, 2).map((team, index) => (
          <React.Fragment key={index}>
            <div className={styles.team}>
              <img src={getImageUrl(team.team_img)} alt={team.team_name} className={styles.logo} />
              <p className={styles.team_name}>{team.team_name}</p>
            </div>
            {/* {index === 0 && teams.length > 1 && ( */}
              {/* <span className={styles.vs}>VS</span> */}
            {/* )} */}
          {/* </React.Fragment> */}
        {/* ))} */} 
      {teamsData.length > 2 && (
        <button
          className={styles.seeMoreButton}
          onClick={() => setShowModal(true)}
        >
          See More
        </button>
      )}

      <p className={styles.dateTime}>
        {game_date} AT {game_time}
      </p>
      {showModal && (
        <div className={styles.modal}>
          <button
              className={styles.closeButton}
              onClick={() => setShowModal(false)}
            >
              X
            </button>
          <div className={styles.modalContent}>
            
            <h2>{sport_name} Teams</h2>
            <div className={styles.modalTeams}>
              {teamsData.map((team, index) => (
                <React.Fragment key={index}>
                  <div className={styles.modalTeam}>
                    <img
                      src={getImageUrl(team?.team_img)}
                      alt={team?.team_name}
                      className={styles.modalLogo}
                    />
                    <p className={styles.modalTeamName}>{team?.team_name}</p>
                  </div>
                  {index < teamsData.length - 1 && (
                    <span className={styles.vs}>VS</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default MatchCard;